const PrimaryFormField = ({
  type,
  icon,
  error,
  label,
  placeholder,
  onBlur,
  name,
  onChange,
  value,
  disabled,
  ...props
}) => {
  return (
    <>
      <label htmlFor={name} className="text-[13px] font-[500px] leading-5">
        {label}
      </label>

      <input
        type={type || "text"}
        required={true}
        value={value}
        name={name}
        onBlur={onBlur}
        disabled={disabled}
        className={`${
          error
            ? "border-hervestError focus:border-hervestError  hover:border-hervestError focus:ring-hervestError"
            : "border-hervestPink focus:border-hervestPink  hover:border-hervestPink focus:ring-hervestPink"
        } appearance-none rounded-md relative block w-full
             px-3 py-3 text-[14px] font-[300px] leading-5 bg-[#F8F1F6] placeholder-[#33343D]
             text-gray-900 border    focus:outline-none 
              focus:z-10 sm:text-sm placeholder:text-[13px] placeholder:font-[500px] placeholder:text-gray-400`}
        placeholder={placeholder || "Fill in the details"}
        onChange={onChange}
        {...props}
        onSubmit={(e) => e.preventDefault()}
      />

      {error && (
        <p className="text-[12px] font-[300px] text-red-500">{error}</p>
      )}
    </>
  );
};

export default PrimaryFormField;
